<script>
    export default {
        name: 'WorkbookNotices',
        props: {
            notes: { type: Array, default: () => [] },
            problems: { type: Array, default: () => [] },
            isBesidePlan: { type: Boolean, default: false }
        },
        methods: {
            severityLabel(severity) {
                if (severity !== 'error') return 'Check';
                return this.isBesidePlan ? 'Error' : 'Blocks';
            }
        }
    };
</script>

<template>
    <div v-if="notes.length" class="border rounded p-3 mb-3">
        <h2 class="h6">{{ isBesidePlan ? 'What the workbook read left out' : 'What the workbook holds but this preview does not' }}</h2>
        <p class="small text-muted mb-2">
            <template v-if="isBesidePlan">
                From the automatic read of the workbook, not from this plan. Check the plan covers it before approving.
            </template>
            <template v-else>Anything listed here will not reach the import. Read it before approving.</template>
        </p>
        <ul class="mb-0 small">
            <li v-for="(note, i) in notes" :key="'n' + i">{{ note }}</li>
        </ul>
    </div>

    <div v-if="problems.length" class="border rounded p-3 mb-3">
        <h2 class="h6">{{ isBesidePlan ? 'Problems in the workbook read' : 'Problems to settle before build-out' }}</h2>
        <p v-if="isBesidePlan" class="small text-muted mb-2">
            From the automatic read of the workbook, not from this plan, so the plan may already settle them. They do not stop the approval.
        </p>
        <ul class="list-unstyled mb-0 small">
            <li
                v-for="(v, i) in problems"
                :key="'v' + i"
                class="d-flex gap-2 py-1 border-top"
            >
                <span
                    class="badge align-self-start"
                    :class="v.severity === 'error' ? 'bg-danger' : 'bg-warning text-dark'"
                >
                    {{ severityLabel(v.severity) }}
                </span>
                <span>
                    {{ v.message }}
                    <span v-if="v.sheet" class="text-muted">
                        &mdash; {{ v.sheet }}<span v-if="v.rowNumber">, row {{ v.rowNumber }}</span>
                    </span>
                </span>
            </li>
        </ul>
    </div>
</template>
